import { GA4Event } from "./GA4Event";

export function buildExpressionImpressionEvent(model, message) {
	const { attributes } = message;
	const baseParams = {
		exp_variant_string: attributes["exp_variant_string"],
		test: attributes["test"],
		variant: attributes["variant"],
		experiment_id: attributes["experiment-id"],
		variant_id: attributes["variant-id"],
		seitentyp: attributes["seitentyp"] || model["seitentyp"] || (model.attributes && model.attributes["seitentyp"]) || ""
	}
	const { eventData } = new GA4Event("experience_impression", baseParams);
	return eventData;
}
